<script setup lang="ts"></script>

<template>
  <div>
    <h1>Base index</h1>
    <ul>
      <li><NuxtLink to="/books">Books</NuxtLink></li>
    </ul>
  </div>
</template>

<style scoped></style>
